var _this = this,
    _jsxFileName = "/builds/zillow/adtech-product/constellation/zrs-cms-messaging/src/StickyOnsiteMessage.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@zillow/constellation/lib/components';
import { OnsiteMessage } from './OnsiteMessage';
export var StickyWrapper = function StickyWrapper(_ref) {
  var _ref2;

  var verticalProperty = _ref.verticalProperty,
      horizontalProperty = _ref.horizontalProperty,
      verticalPosition = _ref.verticalPosition,
      horizontalPosition = _ref.horizontalPosition,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    sx: (_ref2 = {
      position: 'fixed',
      zIndex: '$zIndices.toast'
    }, _ref2[horizontalProperty] = horizontalPosition, _ref2[verticalProperty] = verticalPosition, _ref2),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, children);
};
StickyWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  verticalProperty: PropTypes.oneOf('top', 'bottom'),
  horizontalProperty: PropTypes.oneOf('left', 'right'),
  verticalPosition: PropTypes.string,
  horizontalPosition: PropTypes.string,
  children: PropTypes.node.isRequired
} : {};
StickyWrapper.defaultProps = {
  verticalProperty: 'top',
  horizontalProperty: 'left',
  verticalPosition: '0px',
  horizontalPosition: '0px'
};
export var StickyOnsiteMessage = function StickyOnsiteMessage(_ref3) {
  var messageData = _ref3.messageData,
      placementName = _ref3.placementName,
      additionalProps = _ref3.additionalProps,
      additionalClickStreamData = _ref3.additionalClickStreamData,
      supportedComponents = _ref3.supportedComponents,
      triggerLocation = _ref3.triggerLocation,
      triggerObject = _ref3.triggerObject,
      triggerSource = _ref3.triggerSource,
      Head = _ref3.Head,
      verticalProperty = _ref3.verticalProperty,
      horizontalProperty = _ref3.horizontalProperty,
      verticalPosition = _ref3.verticalPosition,
      horizontalPosition = _ref3.horizontalPosition;
  return /*#__PURE__*/React.createElement(StickyWrapper, {
    verticalProperty: verticalProperty,
    horizontalProperty: horizontalProperty,
    verticalPosition: verticalPosition,
    horizontalPosition: horizontalPosition,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 55,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(OnsiteMessage, _extends({
    messageData: messageData,
    placementName: placementName,
    additionalProps: additionalProps,
    additionalClickStreamData: additionalClickStreamData,
    supportedComponents: supportedComponents,
    triggerLocation: triggerLocation,
    triggerObject: triggerObject,
    triggerSource: triggerSource,
    Head: Head
  }, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  })));
};
StickyOnsiteMessage.propTypes = process.env.NODE_ENV !== "production" ? {
  messageData: PropTypes.shape({
    eventId: PropTypes.string,
    decisionContext: PropTypes.string,
    messages: PropTypes.arrayOf(PropTypes.shape({
      skipDisplayReason: PropTypes.string,
      shouldDisplay: PropTypes.bool,
      isGlobalHoldout: PropTypes.bool,
      isPlacementHoldout: PropTypes.bool,
      placementName: PropTypes.string,
      testPhase: PropTypes.string,
      bucket: PropTypes.string,
      placementId: PropTypes.number,
      passThrottle: PropTypes.bool,
      lastModified: PropTypes.string,
      decisionContext: PropTypes.object,
      eventId: PropTypes.string,
      selectedTreatment: PropTypes.shape({
        component: PropTypes.string,
        id: PropTypes.number,
        lastModified: PropTypes.string,
        name: PropTypes.string,
        renderingProps: PropTypes.string,
        status: PropTypes.string
      }),
      qualifiedTreatments: PropTypes.arrayOf(PropTypes.shape({
        component: PropTypes.string,
        id: PropTypes.number,
        lastModified: PropTypes.string,
        name: PropTypes.string,
        renderingProps: PropTypes.string,
        status: PropTypes.string
      }))
    }))
  }),
  placementName: PropTypes.string,
  additionalProps: PropTypes.shape({
    signalForTriggerTracking: PropTypes.bool
  }),
  // eslint-disable-next-line zillow/react/forbid-prop-types
  additionalClickStreamData: PropTypes.object,

  /*
      Sample illustration of use:
      import { UpsellWrapper } from '@zillow/zrs-cms-messaging/lib/components/UpsellWrapper';
      import { ZOUpsellWrapper } from '@zillow/zrs-cms-messaging/lib/components/ZOUpsellWrapper';
      const components = {
          ZOUpsellWrapper,
          UpsellWrapper,
      };
      return (
          <OnsiteMessage
              messageData={messageData}
              placementName={placementName}
              supportedComponents={components}
          />
      );
  */
  supportedComponents: PropTypes.objectOf(PropTypes.elementType),
  triggerLocation: PropTypes.string,
  triggerObject: PropTypes.string,
  triggerSource: PropTypes.string,
  Head: PropTypes.func,
  verticalProperty: PropTypes.oneOf('top', 'bottom'),
  horizontalProperty: PropTypes.oneOf('left', 'right'),
  verticalPosition: PropTypes.string,
  horizontalPosition: PropTypes.string
} : {};
StickyOnsiteMessage.defaultProps = {
  additionalClickStreamData: {},
  messageData: {},
  placementName: '',
  additionalProps: {},
  supportedComponents: {},
  triggerLocation: '',
  triggerObject: '',
  triggerSource: '',
  Head: undefined,
  verticalProperty: 'top',
  horizontalProperty: 'left',
  verticalPosition: '0px',
  horizontalPosition: '0px'
};